module.exports = __webpack_public_path__ + "img/PINUP.2ac92fd7.svg";